import { render, staticRenderFns } from "./SideBarUpdates.vue?vue&type=template&id=f6fb2188&scoped=true&"
import script from "./SideBarUpdates.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarUpdates.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fb2188",
  null
  
)

export default component.exports